import { createRef, Component } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import Styles from './styles.module.scss';

import withComponentName from '../../decorators/withComponentName';

const cx = classNames.bind(Styles);

export class AnimatedCircleComponent extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.circleElement = createRef();
    this.state = {
      animated: false,
    };
  }

  componentDidMount() {
    window.addEventListener('scroll', this.startAnimate);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.startAnimate);
  }

  startAnimate() {
    const { animated } = this.state;

    if (animated) return;
    if (this.elementInViewport(this.circleElement.current)) {
      this.setState({
        animated: true,
      });
    }
  }

  elementInViewport(el) {
    let top = el.offsetTop;
    let left = el.offsetLeft;
    const width = el.offsetWidth;
    const height = el.offsetHeight;

    while (el.offsetParent) {
      el = el.offsetParent;
      top += el.offsetTop;
      left += el.offsetLeft;
    }
    return (
      top >= window.pageYOffset
      && left >= window.pageXOffset
      && (top + height) <= (window.pageYOffset + window.innerHeight)
      && (left + width) <= (window.pageXOffset + window.innerWidth)
    );
  }

  render() {
    const {
      top = '', left = '', right = '', countCircles, inSection, className = '',
    } = this.props;
    const { animated } = this.state;


    const firstPointClass = cx({
      first: true,
      grow_first: animated,
    });
    const secondPointClass = cx({
      second: true,
      grow_second: animated,
    });
    const thirdPointClass = cx({
      grow_third: animated,
    }, 'third');
    const animPointClass = cx({
      in_section: inSection,
    }, 'anim_point', className);

    const styles = inSection ? null : { top, left, right };

    return (
      <div
        className={animPointClass}
        style={styles}
        ref={this.circleElement}
      >
        {countCircles === 3 && <div className={thirdPointClass} />}
        <div className={secondPointClass} />
        <div className={firstPointClass} />
        <div className={Styles.center} />
        <div className={Styles.centerBack} />
      </div>
    );
  }
}

export default withComponentName(AnimatedCircleComponent);
